export const getMenu = state => state.menu.data;
export const getMenuLoading = state => state.menu.loading;
export const getProfileMenu = state => state.menu.profileData;
export const getProfileMenuLoading = state => state.menu.profileLoading;
export const getProfileMenuFetched = state => state.menu.profileFetched;
